import { Component, Input } from "@angular/core";

@Component({
  selector: "invoice-type",
  styleUrls: ["./invoice-type.component.css"],
  templateUrl: "./invoice-type.component.html"
})
export class InvoiceTypeComponent {
  @Input()
  invoiceType!: string;
}